module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Lock-2a9e4ec93da4e8fd66eac47c942ec0e7.svg";